import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const api = buildService('/claim_groups/{id}/change_sets', {
  only: ['all']
});
const claimGroupChangeSetsService = {
  useFetchChangeSets: function (claimGroupId, setLoading) {
    let fetchImmediately = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (claimGroupId == null) {
          return null;
        }
        const {
          active_change_set,
          change_sets
        } = await api.all(claimGroupId);
        return {
          active_change_set,
          change_sets
        };
      }, [claimGroupId]),
      setLoading,
      fetchImmediately,
      initialStateValue: null
    });
  }
};
claimGroupChangeSetsService.useCrud = (claimGroupId, setLoading, fetchImmediately) => {
  const [changeSetsResponse, setChangeSetsResponse, fetchChangeSets] = claimGroupChangeSetsService.useFetchChangeSets(claimGroupId, setLoading, fetchImmediately);
  return {
    activeChangeSet: changeSetsResponse?.active_change_set,
    changeSets: changeSetsResponse?.change_sets,
    setChangeSetsResponse,
    fetchChangeSets
  };
};
export default claimGroupChangeSetsService;